import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './avatar.scss';

const Avatar = ({ children, className, small, src }) => {
  const defaultAvatar = <svg width="35" height="39" viewBox="0 0 35 39" xmlns="http://www.w3.org/2000/svg"><title>user</title><g fillRule="nonzero" fill="#000"><path d="M34.5 37v-4c0-5.236-4.13-9.5-9.25-9.5H9.75C4.63 23.5.5 27.764.5 33v4a1.5 1.5 0 0 0 3 0v-4c0-3.6 2.81-6.5 6.25-6.5h15.5c3.44 0 6.25 2.9 6.25 6.5v4a1.5 1.5 0 0 0 3 0zM17.5 19.5c-4.993 0-9-4.274-9-9.5s4.007-9.5 9-9.5 9 4.274 9 9.5-4.007 9.5-9 9.5zm0-3c3.291 0 6-2.89 6-6.5s-2.709-6.5-6-6.5-6 2.89-6 6.5 2.709 6.5 6 6.5z" /></g></svg>;

  if (src) {
    return (
      <div className={classnames(className, styles.avatar, {[styles.small]: small})}>
        <img src={src} className={styles.img} alt="" />
      </div>
    );
  }
  return (
    <div className={classnames(className, styles.default, {[styles.small]:small})}>
      {defaultAvatar}
    </div>
  );
};

Avatar.propTypes = {
  className: PropTypes.string,
  small: PropTypes.bool,
  src: PropTypes.string,
};

export { Avatar };


// WEBPACK FOOTER //
// ./src/elements/avatar/avatar.js